module.exports = __webpack_public_path__ + "static/media/calendar-icon.ea5117bc.svg";